angular.module('uti.skayo.onlinesale').controller('ErrorController', function ($scope, $routeParams, $http) {
    $scope.errorMessage = $routeParams.errorMessage;

    $http.get('api/error').then(function(msg){
        $scope.errorMessage = msg.data;
    });

});